import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {FC} from "react";
import {ScaleLoader} from "react-spinners";
import {useTheme} from "@mui/material/styles";

interface Props {
    colSpan: number
    color?: 'primary' | 'secondary'
}

const TableLoader: FC<Props> = ({colSpan, color = 'primary'}) => {
    const theme = useTheme()

    return (
        <TableRow>
            <TableCell colSpan={colSpan}
                       align='center' sx={{'& > span': {display: 'initial !important'}}}>
                <ScaleLoader color={theme.palette[color].main}/>
            </TableCell>
        </TableRow>
    )
}

export default TableLoader